import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { AppSettings } from "../../constants";
import { Popup } from "components/Popup/popup";
import { ContextMenu } from "components/context-menu/context-menu";
import { MessengerBox } from "components/messenger-box/messenger-box";
import { CheckBox } from "components/checkboxes/check-box";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import * as UnitHelper from "helper/unit-helper";
import componentActions from "../../components/actions";
import builderAction from "../actions";
import BuilderInformationModal from "../Components/BuilderInformationModal";
import TableList from "components/TableList";
import ConfirmModal from "components/ConfirmModal";
import auth from "Auth/authenticator";
// import '../../css/tooltip.css';

const defaultParams = {
  defaultSortName: "clientName",
  defaultSortOrder: "ascending",
  sizePerPage: 10,
};

let defaultCheckedValues = [];
AppSettings.CLIENT_STATUS_VALUE.map((item) => {
  defaultCheckedValues.push(item.key);
});

class ManageBuilders extends Component {
  constructor(props) {
    super(props);

    this.roleName = auth.getRoleName();

    this.state = {
      defaultSortName: props.builderStore.ManageBuilder.params.sort.field, // default sort column name
      defaultSortOrder: props.builderStore.ManageBuilder.params.sort.order, // default sort order,
      currentPage: props.builderStore.ManageBuilder.params.skip,
      sizePerPage: props.builderStore.ManageBuilder.params.take,
      totalRecord: props.builderStore.ManageBuilder.params.totalRecord,
      data: props.builderStore.ManageBuilder.items,
      status: props.builderStore.ManageBuilder.params.status,
      currentClient: {},
      oauth_sso: props.builderStore.ManageBuilder.oauth_sso,

      isShowPopup: false,
      checkedValues: [],
    };
  }

  componentWillMount() {
    this.setState({
      checkedValues: defaultCheckedValues,
    });
  }

  componentDidMount() {
    const self = this;
    this.binding(
      this.objToParams(this.props.builderStore.ManageBuilder.params)
    );
    window.addEventListener("click", (e) => {
      // eslint-disable-line
      if (
        document.getElementById("s1-popup") &&
        document.getElementById("s1-popup").contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById("popup-button") &&
          document.getElementById("popup-button").contains(e.target)
        ) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({ isShowPopup: false });
          }
        }
      }
    });
  }

  fetchLotsEnabled = (item_id) => {
    this.props.builderAction.getLotStatusFeature({
      builderId: item_id, // Pass directly instead of nested object
      callback: (response) => {
        console.log("🚀 ~ Response:", response.data);
      },
    });
  };

  componentWillReceiveProps(nextProps) {
    const { ManageBuilder, BuilderOwnerProfile, IsViewClientOwner } =
      nextProps.builderStore;
    if (ManageBuilder && ManageBuilder.params) {
      this.setState({
        totalRecord: ManageBuilder.params.totalRecord,
        data: ManageBuilder.items,
        status: ManageBuilder.params.status,
        currentPage: ManageBuilder.params.skip,
      });
    }

    if (IsViewClientOwner) {
      this.showModalBuilderInformation(BuilderOwnerProfile);
    }

    // if (ManageBuilder.oauth_sso && !isEqual(ManageBuilder.oauth_sso, this.state.oauth_sso)) {
    //   this.setState({oauth_sso: nextProps.ManageBuilder.oauth_sso});
    //   const {currentClient} = this.state;
    //   let token_name = `${currentClient.clientName.replace(' ', '_')}_token`;
    //   let client_id = `${currentClient.clientName.replace(' ', '_')}_uid`;
    //   let refresh = `${currentClient.clientName.replace(' ', '_')}_refresh_token`;
    //   let create = `${currentClient.clientName.replace(' ', '_')}_token_created`;
    //   let expires = `${currentClient.clientName.replace(' ', '_')}_expires`;
    //   localStorage[token_name] = ManageBuilder.oauth_sso.access_token;
    //   localStorage[client_id] = currentClient.id;
    //   localStorage[refresh] = currentClient.refresh_token;
    //   localStorage[create] = moment().unix();
    //   localStorage[expires] = expires;
    //   let url = currentClient.domain + '/account/sso?token=' + ManageBuilder.oauth_sso.access_token + '&id=' + currentClient.id;
    //   // let url = "http://test.localhost:8053/account/sso?token=" + cookie.load(AppSettings.ACCESS_TOKEN_SCHEME) + "&id=" + item.id;
    //   window.open(url,'_blank');
    // }
  }

  componentWillUnmount() {
    this.props.builderAction.resetBuilder({
      params: null,
    });
  }

  onContextMenu(e, item) {
    var contextItem = [];

    if (this.roleName === AppSettings.SYSTEM_ADMINISTRATOR) {
      switch (item.clientStatus) {
        case AppSettings.CLIENT_STATUS.PENDING:
          contextItem = [
            {
              title: "Resend activation email",
              icon: "glyphicon glyphicon-envelope",
              event: this.onResendActiveEmail.bind(this),
            },
            {
              title: "Delete",
              icon: "glyphicon glyphicon-remove",
              event: this.onDelete.bind(this),
            },
          ];
          break;
        case AppSettings.CLIENT_STATUS.ACTIVE:
          contextItem = [
            {
              title: "Go to builder site",
              icon: "glyphicon glyphicon-globe",
              custom: !item.isSetupCompleted
                ? {
                    className: "disable-go-to-builder",
                    render: this.renderContextMenuCantGoToBuilderSite(),
                  }
                : null,
              event: this.onGoToBuilderSite.bind(this),
            },
            {
              title: "View builder information",
              icon: "glyphicon glyphicon-blackboard",
              event: this.onViewBuilderInfomation.bind(this),
            },
            {
              title: "Suspend",
              icon: "glyphicon glyphicon-lock",
              event: this.onSuspend.bind(this),
            },
          ];
          break;
        case AppSettings.CLIENT_STATUS.SUSPENDED:
          contextItem = [
            {
              title: "View builder information",
              icon: "glyphicon glyphicon-blackboard",
              event: this.onViewBuilderInfomation.bind(this),
            },
            {
              title: "Restore",
              icon: "glyphicon glyphicon-refresh",
              event: this.onRestore.bind(this),
            },
          ];
          break;
        default:
          return;
      }
    } else {
      contextItem = [
        {
          title: "Go to builder site",
          icon: "glyphicon glyphicon-globe",
          custom: !item.isSetupCompleted
            ? {
                className: "disable-go-to-builder",
                render: this.renderContextMenuCantGoToBuilderSite(),
              }
            : null,
          event: this.onGoToBuilderSite.bind(this),
        },
        {
          title: "View builder information",
          icon: "glyphicon glyphicon-blackboard",
          event: this.onViewBuilderInfomation.bind(this),
        },
      ];
    }

    this.cxtMenu.state.event(e, item, contextItem);
  }

  toolTip() {
    return (
      <Tooltip className="in tooltip-siteone" id="disable-go-to">
        <span>The builder has not finished setting up their site yet.</span>
      </Tooltip>
    );
  }

  renderContextMenuCantGoToBuilderSite = () => {
    return (
      <span style={{ cursor: "default" }}>
        <span style={{ opacity: 0.4 }}>Go to builder site</span>
        <OverlayTrigger
          placement="top"
          overlay={this.toolTip()}
          delayHide={10}
          delayShow={500}
        >
          <span style={{ fontSize: 15, marginLeft: 5, color: "#E64433" }}>
            <i className="fa fa-exclamation-circle" />
          </span>
        </OverlayTrigger>
      </span>
    );
  };

  customRenderBtnAction(item) {
    if (
      this.roleName === AppSettings.SYSTEM_ADMINISTRATOR ||
      item.clientStatus === AppSettings.CLIENT_STATUS.ACTIVE
    ) {
      return (
        <a
          className="glyphicon glyphicon-option-vertical cls-table-black-icon"
          onClick={(e) => {
            this.onContextMenu(e, item);
          }}
        />
      );
    } else {
      return null;
    }
  }

  customRenderStatus(item) {
    switch (item.clientStatus) {
      case AppSettings.CLIENT_STATUS.PENDING:
        return (
          <div className="pill-indicators warning">
            {item.clientStatusValue}
          </div>
        );
      case AppSettings.CLIENT_STATUS.ACTIVE:
        return (
          <div className="pill-indicators success">
            {item.clientStatusValue}
          </div>
        );
      case AppSettings.CLIENT_STATUS.SUSPENDED:
        return (
          <div className="pill-indicators danger">{item.clientStatusValue}</div>
        );
      default:
        return null;
    }
  }

  onSaveBuilder(e, data, builderActionType) {
    var params = {
      ...this.objToParams(this.props.builderStore.ManageBuilder.params),
      email: this.search.value.trim(),
    };
    this.props.dispatch({
      type: builderActionType,
      params: {
        data: data,
        search: params,
      },
    });
  }

  onResendActiveEmail(e, item) {
    const params = {
      ...this.objToParams(this.props.builderStore.ManageBuilder.params),
      email: this.search.value.trim(),
    };
    this.props.builderAction.resendActiveEmailBuilderAsync({
      params: {
        data: {
          id: item.id,
          redirectUrl: AppSettings.REDIRECT_INVITE_BUILDER,
          clientType: AppSettings.CLIENT_TYPE.Builder,
        },
        search: params,
      },
    });
  }

  onDelete(e, item) {
    const params = {
      ...this.objToParams(this.props.builderStore.ManageBuilder.params),
      email: this.search.value.trim(),
    };

    this.props.toggleModal({
      modalName: "DELETE",
      modalProps: {
        message: `Delete ${item.ownerEmail} ?`,
        cancelText: "Cancel",
        title: "Delete",
        okText: "Delete",
        okButton: "raised",
        okClass: "danger",
        show: true,
        okFunc: () => {
          this.props.builderAction.removeBuilderAsync({
            params: {
              data: {
                id: item.id,
              },
              search: params,
            },
          });

          this.props.toggleModal({ modalName: "", ActiveModal: null });
        },
      },
      ActiveModal: ConfirmModal,
    });
  }

  onGoToBuilderSite(e, item) {
    // this.setState({currentClient: item}, () => {
    //   this.props.builderAction.oauthSso({
    //     data: {
    //       id: item.id,
    //       token: localStorage[AppSettings.S1_TOKEN]
    //     } bgt
    //   });
    // });
    let url =
      window.location.protocol +
      "//" +
      item.domain +
      "/account/sso?token=" +
      localStorage[AppSettings.S1_TOKEN];
    // let url = 'http://nghia.localhost:3001' + '/account/sso?token=' + localStorage[AppSettings.S1_TOKEN];
    // let url = 'http://testbuilder5.localhost:3000' + '/account/sso?id=' + item.id;
    // let url = "http://test.localhost:8053/account/sso?token=" + cookie.load(AppSettings.ACCESS_TOKEN_SCHEME) + "&id=" + item.id;
    // window.open(url,'_blank');

    window.location.href = url;

    // setTimeout(() => {
    //   builder.postMessage({
    //     type: 'SSO_INFO',
    //     id: item.id,
    //     token: localStorage[AppSettings.S1_TOKEN]
    //   }, '*');
    // });
    // var url = item.domain + '/account/sso?token=' + cookie.load(AppSettings.ACCESS_TOKEN_SCHEME) + '&id=' + item.id;
    //var url = "http://test.localhost:8053/account/sso?token=" + cookie.load(AppSettings.ACCESS_TOKEN_SCHEME) + "&id=" + item.id;

    // window.open(url,'_blank');
  }

  onViewBuilderInfomation(e, item) {
    this.props.builderAction.getBuilderByIdAsync({
      params: item.id,
    });
  }

  showModalBuilderInformation(item) {
    this.props.builderAction.getLotStatusFeature({
      builderId: item.id, // Pass directly instead of nested object
      callback: (response) => {
        // console.log("🚀 ~ Response:", response.data);
        const featureData = (response.data && response.data.data) || {};

        this.props.toggleModal({
          modalName: "Builder Modal",
          modalProps: {
            item: item,
            show: true,
            modalName: "Builder Information",
            title: "Builder Information",
            closeModal: this.closeModal.bind(this),
            onUpdateBuilderInformation:
              this.onUpdateBuilderInformation.bind(this),
            onUpdateLotsAction: this.onUpdateLotsAction.bind(this),
            onUpdateHORFSAction: this.onUpdateHORFSAction.bind(this),
            initialLotsEnabled: featureData.lotStatus,
            initialHORFSEnabled: featureData.hasHORFS || false,
          },
          ActiveModal: BuilderInformationModal,
        });
      },
    });
    // item.id && this.fetchLotsEnabled(item.id);
  }

  closeModal = () => {
    this.props.builderAction.closeModalBuilderInformation({});
    this.props.toggleModal({ modalName: "", ActiveModal: null });
  };

  onUpdateBuilderInformation = (data, modalCallback) => {
    console.log("data", data);

    const {
      defaultSortName,
      defaultSortOrder,
      status,
      currentPage,
      sizePerPage,
    } = this.state;

    let params = data.data;

    if (Object.keys(params).includes("streetAddress")) {
      params = {};

      params["streetAddress"] = data.data.streetAddress;

      if (data.data.streetAddress) {
        params["city"] = data.data.location.city;
        params["stateCode"] = data.data.location.state;
        params["stateName"] = data.data.location.state;
        params["zipCode"] = data.data.location.postalCode;
      }
    }

    this.props.builderAction.updateBuilderInformationAsync({
      id: data.id,
      params,
      callback: () => {
        modalCallback();
        this.props.builderAction.searchBuilderAsync({
          params: {
            searchKey: this.search.value,
            sortField: defaultSortName,
            sortOrder: defaultSortOrder,
            status: status,
            skip: currentPage - 1,
            take: sizePerPage,
          },
        });
      },
    });
  };

  onUpdateLotsAction = (data, checked, modalCallback) => {
    this.props.builderAction.updateBuilderLotsAsync({
      params: {
        BuilderId: data.id,
        BuilderName: data.ownerFirstName + data.ownerLastName,
        BuilderDomain: data.domain,
        BuilderEmail: data.clientEmail,
        BuilderStatus: data.clientStatusValue,
        LotPaidStatus: checked,
      },
      callback: (result) => {
        console.log("🚀 ~ result:", result);
        if (modalCallback) {
          modalCallback(result);
        }
      },
    });
  };

  onUpdateHORFSAction = (data, checked, lotsEnabled, modalCallback) => {
    this.props.builderAction.updateBuilderHoRfsAsync({
      params: {
        builderId: data.id,
        name: data.clientName,
        domain: data.domain,
        email: data.clientEmail,
        hasLotPaidFeature: !!lotsEnabled,
        hasHORFS: checked,
      },
      callback: (result) => {
        if (modalCallback) {
          modalCallback(result);
        }
      },
      errorCallback: () => {
        if (modalCallback) {
          modalCallback(null, true);
        }
      },
    });
  };

  onSuspend(e, item) {
    const params = {
      ...this.objToParams(this.props.builderStore.ManageBuilder.params),
      email: this.search.value.trim(),
    };

    this.props.toggleModal({
      modalName: "Suspend",
      modalProps: {
        message: `Suspend ${item.ownerEmail} ?`,
        cancelText: "Cancel",
        title: "Suspend",
        okText: "Suspend",
        okButton: "raised",
        okClass: "danger",
        show: true,
        okFunc: () => {
          this.props.builderAction.suspendedBuilderAsync({
            params: {
              data: {
                id: item.id,
              },
              search: params,
            },
          });

          this.props.toggleModal({ modalName: "", ActiveModal: null });
        },
      },
      ActiveModal: ConfirmModal,
    });
  }

  onRestore() {
    // alert('Not implement now');
    //this.onSaveBuilder(e, {
    //    id: item.id,
    //}, BuilderActionType.RESTORE_BUILDER_ASYNC);
  }

  onTogglePopupFilter = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup,
    });
  };

  onChecked(e, data) {
    var status = UnitHelper.isEmpty(data.toString()) ? "" : data.toString();
    if (status !== "") {
      var params = this.objToParams(
        this.props.builderStore.ManageBuilder.params
      );

      this.binding({
        ...params,
        status: status,
        skip: 0,
      });
    } else {
      this.setState({ data: [] });
    }
  }

  handleChange = (e, value) => {
    if (this.state.checkedValues.includes(value)) {
      this.setState(
        {
          checkedValues: [
            ...this.state.checkedValues.filter((item) => item !== value),
          ],
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    } else {
      this.setState(
        {
          checkedValues: [...this.state.checkedValues, value],
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    }
  };

  onEnter(e) {
    if (e.key === "Enter") {
      this.onSearch(e);
    }
  }

  onTableBinding(configTable) {
    var params = this.objToParams(this.props.builderStore.ManageBuilder.params);
    this.binding({
      ...params,
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take,
    });
  }

  binding(params) {
    this.props.builderAction.searchBuilderAsync({
      //type: BuilderActionType.SEARCH_BUILDER_ASYNC,
      params: params,
    });
  }

  onSearch() {
    var params = this.objToParams(this.props.builderStore.ManageBuilder.params);

    // $('.s1-ckb').map((i, ckb) => { $(ckb).prop('checked', true); });
    this.setState({
      checkedValues: defaultCheckedValues,
    });

    this.binding({
      ...params,
      status: "all",
      skip: 0,
    });
  }

  objToParams(obj) {
    return {
      searchKey: this.search.value.trim(),
      clientType: AppSettings.CLIENT_TYPE.Builder,
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      status: obj.status,
      skip: obj.skip - 1,
      take: obj.take,
    };
  }

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage,
      },
      () => {
        this.props.builderAction.searchBuilderAsync({
          params: {
            searchKey: this.search.value,
            sortField: params.defaultSortName,
            sortOrder: params.defaultSortOrder,
            status: this.state.status,
            skip: params.currentPage - 1,
            take: params.sizePerPage,
          },
        });
      }
    );
  }

  render() {
    const { data } = this.state;

    const column = [
      {
        field: "userId",
        header: "id",
        hidden: true,
        isKey: true,
        sort: false,
        dataAlign: "left",
        headerAlign: "left",
      },
      {
        field: "clientName",
        header: "Name",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
      },
      {
        field: "domain",
        header: "Domain",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
      },
      {
        field: "ownerEmail",
        header: "Owner",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
      },
      {
        field: "clientStatusValue",
        header: "Status",
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderStatus.bind(this),
      },
      {
        field: "",
        header: "",
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: "right",
        headerAlign: "right",
        customRender: this.customRenderBtnAction.bind(this),
        className: "column-action",
        columnClassName: "column-action",
      },
    ];

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: this.state.totalRecord,
    };

    const customHeader = (
      <div className="table-header">
        <Row>
          <Col sm={12} md={12} className="text-right">
            <div className="box-search">
              <div className="input-group">
                <input
                  type="text"
                  id="txt-search-clientName"
                  ref={(ref) => {
                    this.search = ref;
                  }}
                  className="form-control"
                  placeholder="Search"
                  onKeyPress={this.onEnter.bind(this)}
                />
                <span className="input-group-btn">
                  <button
                    onClick={this.onSearch.bind(this)}
                    className="btn btn-secondary"
                  >
                    <span className="fa fa-search" aria-hidden="true" />
                  </button>
                </span>
              </div>
            </div>
            <div className="pull-right manage-user-filter">
              <button
                onClick={this.onTogglePopupFilter}
                className="btn btn-secondary fa fa-filter btn-icon"
                id="popup-button"
              />
              {this.state.isShowPopup && (
                <Popup
                  ref={(ref) => {
                    this.popup = ref;
                  }}
                >
                  {AppSettings.CLIENT_STATUS_VALUE.map((item) => {
                    let className = "checkbox-default";
                    switch (item.key) {
                      case AppSettings.CLIENT_STATUS.ACTIVE:
                        className = "checkbox-success";
                        break;
                      case AppSettings.CLIENT_STATUS.PENDING:
                        className = "checkbox-warning";
                        break;
                      case AppSettings.CLIENT_STATUS.SUSPENDED:
                        className = "checkbox-danger";
                        break;
                      default:
                        break;
                    }
                    return (
                      <CheckBox
                        checked={this.state.checkedValues.includes(item.key)}
                        onChecked={this.onChecked.bind(this)}
                        name="status"
                        className={className}
                        value={item.key}
                        label={item.value}
                        handleChange={this.handleChange}
                      />
                    );
                  })}
                </Popup>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );

    return (
      <div id="manage-user">
        <div className="page-title clearfix">
          <h2 className="pull-left">Builders ({this.state.totalRecord})</h2>
          {this.roleName === AppSettings.SYSTEM_ADMINISTRATOR && (
            <Link
              className="btn btn-primary btn-info btn-siteone pull-right btn-icon"
              to={"/builders/invite-builder"}
            >
              <span className="fa fa-plus icon" />
              NEW
            </Link>
          )}
        </div>
        <MessengerBox
          ref={(ref) => {
            this.msgBox = ref;
          }}
          title={AppSettings.LOGO_30}
        />
        <ContextMenu
          ref={(ref) => {
            this.cxtMenu = ref;
          }}
        />
        <TableList
          ref={(ref) => {
            this.tableList = ref;
          }}
          column={column}
          defaultParams={defaultParams}
          data={data}
          options={options}
          refreshPageList={this.refreshList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          showButtonMenu={true}
          onContextMenu={this.onContextMenu.bind(this)}
          customTableHeader={customHeader}
        />
      </div>
    );
  }
}

ManageBuilders.propTypes = {
  builderStore: PropTypes.object,
  builderAction: PropTypes.object,
  IsViewClientOwner: PropTypes.bool,
  toggleModal: PropTypes.func,
  BuilderOwnerProfile: PropTypes.object,
  dispatch: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    builderStore: state.BuilderStore,
    user: state.authReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleModal: bindActionCreators(componentActions.toggleModal, dispatch),
    builderAction: bindActionCreators(builderAction, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageBuilders);



// WEBPACK FOOTER //
// ./src/Builders/Containers/manage-builders.js